module.exports = __webpack_public_path__ + "static/media/noActivity.c8845442.svg";